import { userConstants } from '../_constants';

let user = JSON.parse(localStorage.getItem('user'));
const initialState = user ? { loggedIn: true, user } : {};

export function authentication(state = initialState, action) {
  switch (action.type) {
    case userConstants.LOGIN_REQUEST:
      return {
        loggingIn: true,
        user: action.user
      };
    case userConstants.LOGIN_SUCCESS:
      return {
        loggedIn: true,
        user: action.user
      };
    case userConstants.LOGIN_FAILURE:
      return {
        loggedIn: false,
        error: action.error
      };
    case userConstants.INFO_SUCCESS:
      // Merge user info with existing token data
      const updatedUser = { ...state.user, ...action.user };
      localStorage.setItem('user', JSON.stringify(updatedUser));
      return {
        ...state,
        loggedIn: true,
        user: updatedUser
      };
    case userConstants.SET_INFO_SUCCESS:
      // Update user info after profile update
      const modifiedUser = { ...state.user, ...action.user };
      localStorage.setItem('user', JSON.stringify(modifiedUser));
      return {
        ...state,
        user: modifiedUser
      };
    case userConstants.LOGOUT:
      return {
        loggedIn: false,
      };
    default:
      return state
  }
}